import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "content", "refKey"];
import React, { useState, useEffect, useRef } from 'react';
import Text from 'components/Text';
import EasyTooltip from 'components/EasyTooltip';
function OverflowTooltip(_ref) {
  var children = _ref.children,
    content = _ref.content,
    _ref$refKey = _ref.refKey,
    refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasOverflow = _useState2[0],
    setHasOverflow = _useState2[1];
  var overflowRef = useRef(null);
  useEffect(function () {
    if (overflowRef.current) {
      var _overflowRef$current = overflowRef.current,
        scrollWidth = _overflowRef$current.scrollWidth,
        offsetWidth = _overflowRef$current.offsetWidth;
      var isOverflowing = scrollWidth > offsetWidth;
      setHasOverflow(isOverflowing);
    }
  }, [children]);
  var tooltipContent = hasOverflow ? content : undefined;

  // Text-only children that don't have a wrapper element
  // get default "ellipsis" overflow styles
  if (typeof children === 'string') {
    return /*#__PURE__*/React.createElement(EasyTooltip, _extends({
      content: tooltipContent,
      placement: "top-start"
    }, otherProps), /*#__PURE__*/React.createElement(Text, {
      ref: overflowRef,
      overflow: "ellipsis",
      display: "block"
    }, children));
  }
  return /*#__PURE__*/React.createElement(EasyTooltip, _extends({
    content: tooltipContent,
    placement: "top-start"
  }, otherProps), /*#__PURE__*/React.isValidElement(children) && /*#__PURE__*/React.cloneElement(React.Children.only(children), _defineProperty({}, refKey, overflowRef)));
}
export default OverflowTooltip;